package com.karawek.core.auth.stytch.di

import com.karawek.core.auth.api.Authenticator
import com.karawek.core.auth.api.AuthTokenProvider
import com.karawek.core.auth.api.local.LocalAuthenticator
import com.karawek.core.auth.stytch.NoOpAuthTokenProvider
import com.karawek.core.auth.stytch.StytchAuthenticator
import com.karawek.core.auth.stytch.StytchAuthTokenProvider
import com.karawek.core.auth.stytch.client.StytchClient
import com.karawek.core.auth.stytch.client.createStytchClient
import com.karawek.core.auth.stytch.config.StytchConfig
import com.karawek.core.platform.PlatformContext
import me.tatarka.inject.annotations.Provides
import me.tatarka.inject.annotations.Qualifier
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesTo
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@Qualifier
annotation class UseLocalAuthenticator

@ContributesTo(AppScope::class)
interface StytchAuthModule {

    /**
     * The single shared Stytch client, or `null` when running with the local
     * (offline) authenticator. Shared so the [Authenticator] and the
     * [AuthTokenProvider] read from the same live SDK session.
     */
    @SingleIn(AppScope::class)
    @Provides
    fun provideStytchClient(
        platformContext: PlatformContext,
        config: StytchConfig,
        @UseLocalAuthenticator useLocalAuthenticator: Boolean,
    ): StytchClient? =
        if (useLocalAuthenticator) {
            null
        } else {
            createStytchClient(
                platformContext = platformContext,
                config = config,
            )
        }

    @SingleIn(AppScope::class)
    @Provides
    fun provideAuthenticator(
        stytchClient: StytchClient?,
    ): Authenticator =
        stytchClient?.let(::StytchAuthenticator) ?: LocalAuthenticator()

    @SingleIn(AppScope::class)
    @Provides
    fun provideAuthTokenProvider(
        stytchClient: StytchClient?,
    ): AuthTokenProvider =
        stytchClient?.let(::StytchAuthTokenProvider) ?: NoOpAuthTokenProvider
}
